import { defineComponent as _defineComponent } from 'vue'
import {
    hasLowerAndUpperCase,
    hasNumberAndSymbol,
    hasPasswordLength,
  } from "@/helpers/validation";

  interface Props {
    password: string;
  }
  type RulesState = ReturnType<typeof rulesState>;

  
export default /*@__PURE__*/_defineComponent({
  __name: 'PasswordProgress',
  props: {
    password: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

  const props = __props;
  const ruleTitles = [
    "Upper and lowercase letters",
    "Between 4 and 16 characters",
    "Contains a number and a symbol",
  ];

  function rulesState(value: string) {
    return {
      upperLowerCase: hasLowerAndUpperCase(value),
      length: hasPasswordLength(value),
      numberAndSymbol: hasNumberAndSymbol(value),
    };
  }
  function isCorrectRule(index: number, value: string): boolean {
    const key = Object.keys(rulesState(value))[index] as keyof RulesState;

    return rulesState(value)[key];
  }
  function isActiveProgressItem(index: number, value: string): boolean {
    const values = Object.values(rulesState(value)).filter((item) => item);

    return Boolean(values[index]);
  }

const __returned__ = { props, ruleTitles, rulesState, isCorrectRule, isActiveProgressItem, get hasLowerAndUpperCase() { return hasLowerAndUpperCase }, get hasNumberAndSymbol() { return hasNumberAndSymbol }, get hasPasswordLength() { return hasPasswordLength } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})